import NoReceiptIcon from "@assets/images/no-remittance-receipt.svg";
import { makeStyles } from "@material-ui/core";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import { RemittanceRunnerRemittances_remittances_edges_node_receiptImage } from "@saleor/remittanceRunner/types/RemittanceRunnerRemittances";
import React from "react";

const useStyles = makeStyles(
  {
    receiptIcon: {
      color: "#0030FF",
      height: "20px",
      width: "18px"
    }
  },
  { name: "RemittanceRunnerTblColReceiptUploaded" }
);

interface RemittanceRunnerTblColReceiptUploadedProps {
  hasRemittanceObject: boolean;
  receiptImage: RemittanceRunnerRemittances_remittances_edges_node_receiptImage;
}

export const RemittanceRunnerTblColReceiptUploaded: React.FC<RemittanceRunnerTblColReceiptUploadedProps> = props => {
  const { hasRemittanceObject, receiptImage } = props;
  const tblClasses = useTableStyles(props);
  const classes = useStyles("");

  const getDisplay = () => {
    if (hasRemittanceObject === false) {
      return <span>-----</span>;
    } else if (receiptImage?.url) {
      return (
        <span>
          <ReceiptOutlinedIcon className={classes.receiptIcon} />
        </span>
      );
    } else {
      return (
        <span>
          <img alt="No Receipt Icon" src={NoReceiptIcon} />
        </span>
      );
    }
  };

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Receipt Uploaded</div>
      <div className={`${tblClasses.dataDisplay} ${tblClasses.textCenter}`}>
        {getDisplay()}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColReceiptUploaded;
